import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface LimitState {
  limit: number | null;
  minOrder: number | null;
  balance: number | null;
  digital: boolean | null;
  // Não persistido: deve sempre iniciar `true` a cada abertura do app, para
  // que a UI mostre o skeleton até o saldo ser buscado de novo (o valor
  // persistido é só o último conhecido, não necessariamente o atual).
  loadingLimit: boolean;
  setLimit: (value: number | null) => void;
  setMinOrder: (value: number | null) => void;
  setBalance: (value: number | null) => void;
  setDigital: (value: boolean | null) => void;
  setLoadingLimit: (value: boolean) => void;
  clearData: () => void;
}

type PersistedLimitState = Pick<LimitState, 'limit' | 'minOrder' | 'balance' | 'digital'>;

export const useLimitStore = create(
  persist<LimitState, [], [], PersistedLimitState>(
    set => ({
      limit: null,
      minOrder: null,
      balance: null,
      digital: null,
      loadingLimit: true,

      setLimit: (value: number | null) => set(state => ({ ...state, limit: value })),
      setMinOrder: (value: number | null) => set(state => ({ ...state, minOrder: value })),
      setBalance: (value: number | null) => set(state => ({ ...state, balance: value })),
      setDigital: (value: boolean | null) => set(state => ({ ...state, digital: value })),
      setLoadingLimit: (value: boolean) => set(state => ({ ...state, loadingLimit: value })),

      clearData: () =>
        set(() => ({
          limit: null,
          minOrder: null,
          balance: null,
          digital: null,
          loadingLimit: true,
        })),
    }),
    {
      name: 'limit_store',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: state => ({
        limit: state.limit,
        minOrder: state.minOrder,
        balance: state.balance,
        digital: state.digital,
      }),
    },
  ),
);
